import qs from 'qs';

import {
	ActiveDirectoryAuthUtils,
} from '../../../libs/IdeLink.Web.Common/src/modules/Auth/Services/Authentication/ActiveDirectory/ActiveDirectoryAuthUtils';
import {
	LoginMethod,
} from '../../../libs/IdeLink.Web.Common/src/modules/Auth/Services/Authentication/AuthenticationConstants';
import {
	AuthenticationState,
} from '../../../libs/IdeLink.Web.Common/src/modules/Auth/Services/Authentication/AuthenticationState';
import {
	AuthenticationUtils,
} from '../../../libs/IdeLink.Web.Common/src/modules/Auth/Services/Authentication/Base/AuthenticationUtils';
import {
	EmailAuthUtils,
} from '../../../libs/IdeLink.Web.Common/src/modules/Auth/Services/Authentication/Email/EmailAuthUtils';
import {
	GoogleAuthUtils,
} from '../../../libs/IdeLink.Web.Common/src/modules/Auth/Services/Authentication/Google/GoogleAuthUtils';
import { XHRRequest } from '../../../libs/IdeLink.Web.Common/src/services/api';
import { StoreProvider } from '../../../libs/IdeLink.Web.Common/src/redux/StoreProvider';
import { MediaItem, MediaItemHelper } from '../../models/MediaItem';
import { MediasApiUrls } from './MediasApiUrls';
import { ConfigFactory } from '../../../libs/IdeLink.Web.Common/src/configs/ApiConfig';

export interface GetAuthenticatedUrlFromAuthStateParams {
    url?: string,
    authState?: AuthenticationState,
    defaultImage?: string,
    params?: { width?: number, height?: number }
}

type ImageParams = { defaultImage?: string, width: number, height: number }

export class MediasUtils {

    public static imageUrl = (id?: string): string => id ? `${ConfigFactory.getRoot()}${MediasApiUrls.IMAGE(id)}` : '';

    public static toImageUrl = (imageId?: string, params?: ImageParams) => {
        const url = MediasUtils.imageUrl(imageId);
        const mediaItem = MediaItemHelper.toMediaItem(imageId, url);
        return MediasUtils.toAuthenticatedImageUrl(mediaItem, params);
    }

    public static toAuthenticatedImageUrl(mediaItem?: MediaItem, params?: ImageParams) {
        const { defaultImage = '', width = 200, height = 200 } = params || {};
        const authState = StoreProvider.getAppState().Authentication;
        const url = mediaItem ? mediaItem.url : '';
        return MediasUtils.getAuthenticatedUrlFromAuthState(
            { url, authState, defaultImage, params: { width, height } }
        );
    }

    public static getAuthenticatedUrlFromAuthState = ({ url,
        authState,
        defaultImage = '',
        params = { width: 200, height: 200 }
    }: GetAuthenticatedUrlFromAuthStateParams) => {

        if (!url || !authState) return defaultImage || '';

        let authQuery = '';

        const loginMethod: LoginMethod = authState.get('loginMethod');
        if (AuthenticationUtils.isLoginMethodGoogle(loginMethod)) {
            authQuery = GoogleAuthUtils.getAuthorizationFromToken(authState.get('token').token);
        }
        if (AuthenticationUtils.isLoginMethodUsername(loginMethod)) {
            authQuery = EmailAuthUtils.getAuthorizationFromToken(authState.get('access_token'));
        }
        if (AuthenticationUtils.isLoginMethodActiveDirectory(loginMethod)) {
            authQuery = ActiveDirectoryAuthUtils.getAuthorizationFromToken(authState.get('ad_access_token'));
        }

        const questionMarkIndex = url.indexOf('?');
        const baseUrl = questionMarkIndex > 0 ? url.substring(0, questionMarkIndex) : url;
        const search = questionMarkIndex > 0 ? url.substring(questionMarkIndex) : '';

        const queries = XHRRequest.toStringParams({
            ...qs.parse(search, { ignoreQueryPrefix: true }),
            Authorization: authQuery,
            ...params,
        });
        const imageUrl: string = `${baseUrl}${queries}`;
        return imageUrl
    };

    public static toAuthenticatedUrlFromToken = (url: string, token: string, customParams = {}) => {
        if (!url || !token) return '';
        const stringParams = XHRRequest.toStringParams({ Authorization: token, ...customParams });
        return `${url}${stringParams}`;
    };
}

export const useAuthenticatedImageUrl = (url: string = '', params?: ImageParams) => {
    const { defaultImage = '', width, height } = params || {};
    const authState = StoreProvider.getAppState().Authentication;
    return MediasUtils.getAuthenticatedUrlFromAuthState(
        { url, authState, defaultImage, params: { width, height } }
    );
}